import React, { useState } from "react";
import axios from "axios";

const API_URL = "/api";

export default function Register({ onSwitch }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  function validatePassword(password) {
  if (password.length < 8) {
    return "Password must be at least 8 characters.";
  }
  if (!/[A-Z]/.test(password)) {
    return "Password must contain at least one uppercase letter.";
  }
  if (!/[0-9]/.test(password)) {
    return "Password must contain at least one number.";
  }
  return "";
}

async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);
    const passwordError = validatePassword(password);
    if (passwordError) {
      setError(passwordError);
      setLoading(false);
      return;
    }
    try {
      await axios.post(`${API_URL}/register`, {
        name,
        email,
        username,
        password
      });
      setSuccess("Register successful! Please login.");
      setName(""); setEmail(""); setUsername(""); setPassword("");
    } catch (err) {
      if (err.response?.status === 409 || (err.response?.data?.error && err.response.data.error.toLowerCase().includes('e-mail'))) {
        setError("This e-mail is already registered.");
      } else {
        setError(
          err.response?.data?.error || "Error registering. Please try again."
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2>Register</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Nome completo"
            value={name}
            onChange={e => setName(e.target.value)}
            required
          />
          <input
            type="email"
            placeholder="E-mail"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={e => setUsername(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          <p className="password-hint" style={{fontSize:'0.78rem',color:'var(--text-muted)',marginTop:'-4px',lineHeight:'1.5'}}>
            🔒 Min. 8 chars, 1 uppercase, 1 number
          </p>
          <button type="submit" disabled={loading}>
            {loading ? "Creating account…" : "Create Account"}
          </button>
          {error && <div className="error-message">{error}</div>}
          {success && <div className="success-message" style={{color:'var(--accent-green)',background:'rgba(63,185,80,0.1)',border:'1px solid rgba(63,185,80,0.3)',borderRadius:'8px',padding:'12px 16px',fontSize:'0.875rem'}}>{success}</div>}
        </form>
        <p>
          Already have an account?{' '}
          <button className="link-btn" onClick={onSwitch}>
            Login
          </button>
        </p>
      </div>
    </div>
  );
}
